module.exports = __webpack_public_path__ + "img/questionmark.0573367f.png";